

























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { MediumHeavyService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { MediumHeavyModel } from '@/models/config'

@Component({
    name: 'TableListMediumHeavy',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListMediumHeavy extends Vue {
    loading = false
    items: [MediumHeavyModel] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'heavy',
            sortable: true,
            label: 'Pesada'
        },
        {
            key: 'piece',
            sortable: true,
            label: 'Pieza'
        },
        {
            key: 'rate',
            sortable: true,
            label: 'Tarifa'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getheavyWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getheavyWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getheavyWithPagination()
    }

    async getheavyWithPagination () {
        this.loading = true
        const response = await MediumHeavyService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
